export default __webpack_public_path__ + "static/media/buffer.b43559c4.svg";